import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    FaMobileAlt
} from "react-icons/fa";
import { AiOutlineUserAdd } from "react-icons/ai";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { TfiPackage } from "react-icons/tfi";
import { FiLock } from "react-icons/fi";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { RiSecurePaymentLine } from "react-icons/ri";
import { Helmet } from "react-helmet-async";

import "./StartStore.scss";

const brandName =
    window.location.origin === "https://www.xn--nrbutik-5wa.se"
        ? "Närbutik.se"
        : "Nookshop";

const StartaButik = () => {
    return (
        <>
            <Helmet>
                <title>{brandName} | Så startar du din obemannade butik</title>
                <meta
                    name="description"
                    content="Lär dig hur du startar en obemannad butik steg för steg. Välj paket, registrera konto, installera lås och kom igång med smart självservice."
                />
            </Helmet>
            <main className="starta-page">
                <div className="starta-wrapper">
                    <Container>
                        <h1 id="start-store-title" className="page-title text-center">
                            Så startar du din obemannade butik
                        </h1>
                        <p className="page-intro text-center">
                            Här ser du steg för steg hur du kommer igång med en obemannad butik – från val av abonnemang till färdig butik redo för kunder.
                        </p>

                        <Row className="g-4 mt-4" as="section" aria-labelledby="steps-title">

                            {/* Steg 1 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <TfiPackage className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>1. Välj paket</h3>
                                        <p>
                                            Välj det abonnemang som passar din obemannade butik och dina behov bäst.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* Steg 2 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <AiOutlineUserAdd className="step-icon" aria-hidden="true" />


                                    <div className="card-content">
                                        <h3>2. Registrera dig</h3>
                                        <p>
                                            Välj ett paket och registrera ett konto för att komma igång med din butik.
                                        </p>
                                    </div>

                                    <Button
                                        as={Link}
                                        to="/pris"
                                        className="step-button"
                                        title="Se abonnemang och priser för obemannad butik"
                                    >
                                        Se abonnemang
                                    </Button>
                                </Card>
                            </Col>

                            {/* Steg 3 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <RiSecurePaymentLine className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>3. Skaffa Swish Handel</h3>
                                        <p>
                                            Ansök om Swish Handel och ange Närbutik som teknisk kontakt för betalningslösningen.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* Steg 4 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <FiLock className="step-icon" aria-hidden="true" />


                                    <div className="card-content">
                                        <h3>4. Installera lås eller kyl</h3>
                                        <p>
                                            Installera ett digitalt lås eller ett uppkopplat kylskåp för att ge kunder säker tillgång till butiken.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* Steg 5 */}
                            <Col md={4}>
                                <Card className="step-card">
                                    <HiOutlineRocketLaunch className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>5. Öppna butiken</h3>
                                        <p>
                                            När allt är installerat och klart kan du öppna butiken och börja ta emot dina första kunder.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                            {/* SISTA ORANGE KORTET */}
                            <Col md={4}>
                                <Card className="step-card final-card">
                                    <IoMdCheckmarkCircleOutline className="step-icon" aria-hidden="true" />

                                    <div className="card-content">
                                        <h3>KLART!</h3>
                                        <p>
                                            Din obemannade butik är nu igång och redo att ta emot kunder dygnet runt.
                                        </p>
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </Container>
                    <p className="starta-more text-center">
                        Vill du jämföra olika alternativ? Se våra <Link to="/pris">abonnemang och priser</Link>.
                    </p>
                </div>
            </main>
        </>
    );
};

export default StartaButik;